import PropTypes from 'prop-types';
import { useMemo } from 'react';

import productData from 'services/productData';
import QueryParametersParser from 'services/QueryParametersParser';
import { getAppNameByID } from 'services/utility';

import CommonContextV2 from './context';

const CommonContextV2Provider = ({ children, location }) => {
    const query = QueryParametersParser.parse(location?.search);

    const appId = useMemo(() => query?.app, [query]);

    const appName = useMemo(() => location.state?.appName || getAppNameByID(appId), [appId]);

    const productInfo = useMemo(() => productData[appName] ?? productData.MyOPSWAT, [appName]);

    const contextValue = useMemo(
        () => ({
            query,
            appId,
            appName,
            productInfo
        }),
        [query, appId, appName, productInfo]
    );

    return <CommonContextV2.Provider value={contextValue}>{children}</CommonContextV2.Provider>;
};

export default CommonContextV2Provider;

CommonContextV2Provider.propTypes = {
    children: PropTypes.node,
    location: PropTypes.object
};
